import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "bf-modal",
  templateUrl: "./modal.component.html",
  styleUrls: ["./modal.component.scss"],
})
export class ModalComponent implements OnInit {
  @Input() content;

  constructor(public activeModal: NgbActiveModal) {}
  ngOnInit(): void {
    const x = document.getElementsByClassName("modal-content");
    x[0].className = ""; //TO DO FIX THIS
  }
}
